// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./src/components/DashBoard/ViewAccount/UserInfo/UserInfo.css
// module id = 704
// module chunks = 0